import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=b6476b28&"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/assets/stylesheets/components/_dashboard-breadcrumb.scss?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fopt%2Fatlassian%2Fpipelines%2Fagent%2Fbuild%2Fsrc%2Fviews%2Fshared%2FTheBreadcrumb.vue&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBreadcrumbs,
  VLayout,
})
